export const hjEvent = (type: string, name: string) => {
  try {
    if (type === 'event') {
      hj('event', name)
    }
  } catch (e) {
    /* empty */
  }
}
